import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';

export class ProfileButton extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      color: Theme.Colors.ProfilePage.InteractionUnfocused,
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: 5,
      },
      Title: {
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
        text: {
          text: 'Title',
          ...Theme.Fonts.Default,
        },
      },
    };
  }

  set title(t) {
    this.tag('Title').text.text = t;
  }

  set radius(r) {
    this.shader.radius = r;
  }

  set fontSize(size) {
    this.tag('Title').text.fontSize = size;
  }

  _focus() {
    this.color = Theme.Colors.ProfilePage.InteractionFocused;
  }

  _unfocus() {
    this.color = Theme.Colors.ProfilePage.InteractionUnfocused;
  }

  _handleEnter() {
    this.signal('onActivate', this);
  }
}
